export default __webpack_public_path__ + "static/media/Multiplication_03.042ef57c.png";